export default "__VITE_ASSET__wBdlaYA7__"